import { ChevronLeft, ChevronRight } from 'lucide-react'

/** Customer-styled page navigation controls. */
export function Pagination({
  page,
  totalPages,
  onPageChange,
}: {
  page: number
  totalPages: number
  onPageChange: (page: number) => void
}) {
  if (totalPages <= 1) return null

  return (
    <div className="flex items-center justify-center gap-4 pt-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className="inline-flex cursor-pointer items-center gap-1 text-label-sm font-semibold transition-opacity disabled:cursor-default disabled:opacity-30"
      >
        <ChevronLeft className="size-4" aria-hidden />
        Previous
      </button>
      <span className="text-label-sm text-muted-foreground">
        Page {page} of {totalPages}
      </span>
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="inline-flex cursor-pointer items-center gap-1 text-label-sm font-semibold transition-opacity disabled:cursor-default disabled:opacity-30"
      >
        Next
        <ChevronRight className="size-4" aria-hidden />
      </button>
    </div>
  )
}
